import script from "./SearchMessageItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./SearchMessageItem.vue?vue&type=script&setup=true&lang=ts"

import "./SearchMessageItem.vue?vue&type=style&index=0&id=22eb98ac&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-22eb98ac"]])

export default __exports__